import { useState } from 'react';
import MPs from './MPs/MPs';

import styles from './MasterPlan.module.scss';
import { useEffect } from 'react';
import { getMPMainText } from '../../../requests/getMPMainText';
import MainContainerLeftControl from '../../universal_components/MainContainerLeftControl/MainContainerLeftControl';

const MasterPlan = () => {
  const [text, setText] = useState();

  useEffect(() => {
    getMPMainText().then((data) => setText(data));
  }, []);

  return (
    <div className={styles.wrapper}>
      <MainContainerLeftControl widthAside={'280px'} pageName={'Мастер-планы'}>
        {text && <MPs text={text.find((item) => item.id === 1)} text2={text.find((item) => item.id === 3)} />}
      </MainContainerLeftControl>
    </div>
  );
};

export default MasterPlan;
